export { ClickAndCollectButtonRenderer } from './ClickAndCollectButtonRenderer'
export type { ClickAndCollectButtonRendererProps } from './ClickAndCollectButtonRenderer'
